import { Box, Typography } from '@mui/material';

export function EmptyState() {
  return (
    <Box sx={{ px: 2, py: 2 }} role="status" aria-label="No items available">
      <Typography variant="body2" color="text.secondary" fontSize="0.875rem">
        No items
      </Typography>
    </Box>
  );
}
